import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { EMPTY, Observable, catchError } from "rxjs";
export class ErrorInterceptor implements HttpInterceptor {
  router = inject(Router);

  constructor() {
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> { 
    return next.handle(req).pipe(
      catchError((error) => {
        // Used for the email validation, 409 is not an error, but a conflict, it's OK.
        if (error.status === 409) { 
          throw error;
        }

        if (error && error.error && error.error.detail && error.error.detail.code) { 
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const code = error.error.detail.code as any
          if (code === "ERROR_USER_EXPIRED") { 
            this.router.navigate(['/error'], { queryParams: { code },  skipLocationChange: true });
          }
        } else { 
          this.router.navigate(['/error'])
        }
        return EMPTY;
      }))
    }
  }
    
